import React from "react";
import { loadStores } from "../../../api_calls/campaigns";
import { useDispatch, useSelector } from "react-redux";
import { deleteItems, updateStateData } from "../../../Store/actions";
import MultiSelect from "../Selectors/MultiSelect";
import { DetailedSelectionIconWithTooltip } from "../../../api_calls/utils";
import StoreDetailTable from "../DetailedStore/StoreSelectionModal";

const BrandStoresFilter = ({ usedFor }) => {
  const storeDetails = useSelector((state) => state.userSelections);
  const [showSelectionModal, setShowSelectionModal] = React.useState(false);
  const dispatchAction = useDispatch();

  let detailedStoresListForCampaign = typeof storeDetails.campaign_stores_list !== "undefined" && storeDetails.campaign_stores_list.length !== 0
    ? storeDetails.campaign_stores_list
    : [];

  let storeList =
    detailedStoresListForCampaign.length !== 0
      ? detailedStoresListForCampaign.map(store => store.name).sort()
      : [];


  // React.useEffect(() => {
  //   loadStores();
  // }, []);

  return (
    <>
      <MultiSelect
        enableFullWidth={true}
        elemId={usedFor + "_select"}
        label={"Store"}
        options={storeList.map((storeName) => {
          return { value: storeName, label: storeName };
        })}
        defaultVal={
          typeof storeDetails.brand_filters !== "undefined" &&
            typeof storeDetails.brand_filters[usedFor] !== "undefined" &&
            typeof storeDetails.brand_filters[usedFor].stores !== "undefined"
            ? storeDetails.brand_filters[usedFor].stores.map((storeName) => {
              return { value: storeName, label: storeName };
            })
            : []
        }
        selectionCheck={(option, value) => option.label === value.label}
        usedFor="brandStore"
        onChangeCall={(selectedOption) => {
          let userChoices = [];
          const preselectedBrandFilters = typeof storeDetails.brand_filters !== "undefined" ? storeDetails.brand_filters : {};
          selectedOption.forEach((chosen) => {
            if (chosen.label !== "(All)") {
              userChoices.push(chosen.label);
            } else {
              userChoices.push([...new Set(storeList)]);
            }
          });
          dispatchAction(
            updateStateData({
              brand_filters: {
                ...preselectedBrandFilters,
                [usedFor]: {
                  ...preselectedBrandFilters[usedFor],
                  stores: userChoices,
                },
              },
              report_filter_saved: false,
            })
          );
        }}
        additionalIconWithTooltip={true}
        additionalIconMarkup={(setOpen) => {
          return DetailedSelectionIconWithTooltip((e) => {
            e.stopPropagation();
            setOpen(false);
            setShowSelectionModal(true);
          })
        }}
        allowDuplicates={true}
      />


      {
        showSelectionModal && (
          <StoreDetailTable
            open={showSelectionModal}
            onClose={() => {
              setShowSelectionModal(false)
              dispatchAction(deleteItems(["store_selection_pagination", "store_list_filter_applied", "detailed_stores_filtered"]));
            }}
            applyChangesOnSelect={false}
            selectedValues={typeof storeDetails.brand_filters !== "undefined" &&
              typeof storeDetails.brand_filters[usedFor] !== "undefined" &&
              typeof storeDetails.brand_filters[usedFor].stores !== "undefined"
              ? detailedStoresListForCampaign.filter(storeDetail => storeDetails.brand_filters[usedFor].stores.includes(storeDetail.name)).map(storeDtl => storeDtl.id)
              : []}
            toHandleApplyChanges={(selectedStoreIds, selectedStoreNames) => {
              // when user selects stores from the detailed selection modal, we want to update the filter drawer's draft filters but not apply the filters yet until user clicks on apply button
              const preselectedBrandFilters = typeof storeDetails.brand_filters !== "undefined" ? storeDetails.brand_filters : {};

              dispatchAction(
                updateStateData({
                  brand_filters: {
                    ...preselectedBrandFilters,
                    [usedFor]: {
                      ...preselectedBrandFilters[usedFor],
                      stores: selectedStoreNames.map(selectedStore => selectedStore.label),
                    },
                  },
                  report_filter_saved: false,
                })
              );
            }}
            storeOptionsList={detailedStoresListForCampaign}
          />
        )
      }
    </>
  );
};

export default BrandStoresFilter;
